import QRCode from 'qrcode';

export const getFlatNumberCaption = (flatNumber = '') => {
  const numberParts = flatNumber.trim().match(/\d+/g);
  return numberParts?.length ? numberParts[numberParts.length - 1] : flatNumber.trim();
};

// Generate QR code for vehicle with simple vehicle number format
export const generateVehicleQR = async (vehicleNumber, flatNumber = '') => {
  try {
    // Simple format: just the vehicle number
    const qrData = vehicleNumber.trim().toUpperCase();
    
    // Generate QR code as data URL
    const qrCodeDataUrl = await QRCode.toDataURL(qrData, {
      width: 300,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      }
    });

    const normalizedFlatNumber = flatNumber.trim().toUpperCase();
    const dataUrl = normalizedFlatNumber
      ? await addFlatNumberLabel(qrCodeDataUrl, normalizedFlatNumber)
      : qrCodeDataUrl;
    
    return {
      data: qrData,
      dataUrl,
      flatNumber: normalizedFlatNumber
    };
  } catch (error) {
    console.error('Error generating QR code:', error);
    throw error;
  }
};

// Generate QR code as SVG string
export const generateVehicleQRSVG = async (vehicleNumber) => {
  try {
    const qrData = vehicleNumber.trim().toUpperCase();
    
    const qrCodeSVG = await QRCode.toString(qrData, {
      type: 'svg',
      width: 300,
      margin: 2
    });
    
    return {
      data: qrData,
      svg: qrCodeSVG
    };
  } catch (error) {
    console.error('Error generating QR code SVG:', error);
    throw error;
  }
};

// Generate multiple QR codes for testing
export const generateTestQRCodes = async () => {
  const vehicles = [
    { number: 'AP39KU2747', flat: 'FLAT001' },
    { number: 'KA05MN1234', flat: 'FLAT002' },
    { number: 'TN09AB5678', flat: 'FLAT003' }
  ];
  
  const qrCodes = [];
  
  for (const vehicle of vehicles) {
    try {
      const qr = await generateVehicleQR(vehicle.number, vehicle.flat);
      qrCodes.push({
        vehicleNumber: vehicle.number,
        flatId: vehicle.flat,
        ...qr
      });
    } catch (error) {
      console.error(`Failed to generate QR for ${vehicle.number}:`, error);
    }
  }
  
  return qrCodes;
};

const addFlatNumberLabel = (qrCodeDataUrl, flatNumber) => new Promise((resolve, reject) => {
  const image = new Image();

  image.onload = () => {
    const labelHeight = 52;
    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height + labelHeight;

    const context = canvas.getContext('2d');
    if (!context) {
      reject(new Error('Unable to prepare the QR code image'));
      return;
    }

    context.fillStyle = '#FFFFFF';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0);
    context.fillStyle = '#000000';
    context.font = 'bold 22px Arial, sans-serif';
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillText(getFlatNumberCaption(flatNumber), canvas.width / 2, image.height + labelHeight / 2);

    resolve(canvas.toDataURL('image/png'));
  };

  image.onerror = () => reject(new Error('Unable to load the generated QR code'));
  image.src = qrCodeDataUrl;
});
